import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-bookmark-topic-summery-card',
  templateUrl: './bookmark-topic-summery-card.component.html',
  styleUrls: ['./bookmark-topic-summery-card.component.css']
})
export class BookmarkTopicSummeryCardComponent implements OnInit {

  @Input() topicName: string;
  @Input() flashcardData:any;
  @Input() allTopicsSummeryProgress:any;
  @Input() isFromMyLibrary:any;
  completedCount = 0;
  @Input() isFromMyHistory:any;
  noOfViews:any;
  constructor(public router: Router, public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.noOfViews = this.getNoOfViews();
    this.getTopicSummaryProgress();
  }
  getNoOfViews(){
    return this.selfLearnService.generateRandomNumber();
  }
  getTopicSummaryProgress(){
    const topic = this.allTopicsSummeryProgress?.filter((element:any) => this.flashcardData.topicId == element.topicId);
    if(topic){this.completedCount = topic[0]?.count || 0}
    // this.selfLearnService.getTopicSummaryProgress().subscribe((resp:any) => {
    //   const topic = resp?.data?.filter((element:any) => this.flashcardData.topicId == element.topicId);
    //   if(topic){this.completedCount = topic[0]?.count || 0}
    // });
  }
  navigateToTopicDetails(){
    localStorage.setItem("selfLearnSelectedSubject",this.flashcardData.subjectId);
    localStorage.setItem('selfLearnSelectedSubjectName',this.flashcardData.nodeName);
    localStorage.setItem("chapterId",this.flashcardData.chapterId);
    localStorage.setItem("chapterName",this.flashcardData.topicName);
    localStorage.setItem("selfLearnSelectedTopicId", this.flashcardData.topicId);
    localStorage.setItem("selfLearnSelectedTopicName", this.flashcardData.topicName);
    localStorage.setItem('isFromHomeScreen','true');
    let flashcardDetails:any = {
      "subjectId": this.flashcardData.subjectId,
      "topicId": this.flashcardData.topicId,
      "topicName": this.flashcardData.topicName,
      // "subtopicsCount": 9,
      // "publishedFlashcardCount": 5,
      // "publishedVideoCount": 9,
      // "flashcardTaggedQuestionsCount": 17
  }
    localStorage.setItem("SelectedFlashcardData", JSON.stringify(flashcardDetails));
    localStorage.setItem('previousScreen', !this.isFromMyLibrary ?this.isFromMyHistory ? 'selfLearn-V2/my-history' :'selfLearn-V2/bookmarks': 'selfLearn-V2/my-library')
    this.router.navigateByUrl("selfLearn-V2/topic-summary-details");
  }

}
